"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
function Cross({ size = 20, fill = "#fff", title = "cross", ...rest }) {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, fill: fill, viewBox: "0 0 16 16", ...rest },
        react_1.default.createElement("title", null, title),
        react_1.default.createElement("path", { d: "M9.41,8l2.83,2.83-1.41,1.41L8,9.41l-2.8,2.8L3.79,10.8,6.59,8,3.76,5.17,5.17,3.76,8,6.59l2.83-2.83,1.41,1.41Z" })));
}
exports.default = Cross;
//# sourceMappingURL=index.js.map